import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';


import { DialogoConfirmacionComponent } from '../DialogConfirmacion/dialogo-confirmacion.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


/**
* @author Camilo
* @since  23/11/2017
**/
@Component({
	selector: 'contratoUsuarios',
	templateUrl: './AsignarContratoUsuarioIndex.component.html',
	styleUrls: ['../../../../styles.css']
})
export class AsignarContratoUsuarioComponent {


	public listadoUsuarios: Array<opciones>;
	public listadoContrato: Array<opciones>;
	public cusuario: string = "";
	public ciddoc: string = "";
	public mensaje: string = "..";
	public listadoContratos: string="";

	public ocultar: boolean = false;
	

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router,public dialogo: MatDialog) {


		this.listadoUsuarios = new Array();
		this.listadoContrato = new Array();
		this.snackBar.dismiss();

		_route.params.subscribe(params => {

			this.cusuario = params['cusuario'];
			this.ciddoc = params['ciddoc'];
			_serviciosGenerales.get('negociosSistema', { cusuario: params['cusuario'], ntipoempresa: JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa }).subscribe(
				result => {
					console.log(result);
					for (let x in result) {
						this.listadoUsuarios.push(new opciones(false, result[x].cnumcont.split(' ').join('')));
					}
				}, error => {
					this.openSnackBarEspecial('Ocurrió un error mientras se cargan los usuarios del contrato', 'X');
				});

				
			_serviciosGenerales.get('contratoUsuario', { cusuario: params['cusuario'], ntipoempresa: JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa }).subscribe(
				result => {
					console.log(result);
					for (let x in result) {
						this.listadoContrato.push(new opciones(false, result[x].cnumcont.split(' ').join('')));
					}
				}, error => {
					this.openSnackBarEspecial('Ocurrió un error mientras se cargan los usuarios del contrato', 'X');
				});

		})

	}

	listadoContratosSeleccionadosAsignar(){
		let indices: Array<number> = new Array();
		for (let y = this.listadoUsuarios.length - 1; y >= 0; y--) {
			if (this.listadoUsuarios[y].seleccion == true) {
				this.listadoContratos =  this.listadoContratos+' - '+this.listadoUsuarios[y].cnumcont;
			}
		}
	}

	listadoContratosSeleccionadosDescartar(){
		let indices: Array<number> = new Array();
		for (let y = this.listadoContrato.length - 1; y >= 0; y--) {
			if (this.listadoContrato[y].seleccion == true) {
				console.log(this.listadoContrato[y]);
				this.listadoContratos =  this.listadoContratos+' - '+this.listadoContrato[y].cnumcont;
			}
		}
	}

	public asignar() {
		let indices: Array<number> = new Array();
		for (let y = this.listadoUsuarios.length - 1; y >= 0; y--) {
			if (this.listadoUsuarios[y].seleccion == true) {
				indices.push(y);
			}
		}

		for (let y = indices.length - 1; y >= 0; y--) {
			let x = indices[y];
			if (this.listadoUsuarios[x] != undefined && this.listadoUsuarios[x].seleccion == true) {
				this.openSnackBar('Guardando...', 'X');
				let parametros =
			{
				"USUARIO" : JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().usuario).usuario,
				"NUMCONTRATO": this.listadoUsuarios[x].cnumcont,
				"USUARIOMODIF": this.cusuario,
				"TPEMPRESA": ""+JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa+"",
				"NUM": '1'
			}

				this._serviciosGenerales.get('procedure/PRC_ASIGNARCONTRATOS', parametros).subscribe(
						result => {

							this.openSnackBar('Cambios Guardados Correctamente', 'X');
							
						}, error => {
							this.openSnackBarEspecial('Ocurrió un error mientras se cargan los usuarios del contrato', 'X');
						
						});
			}
		}

		this.listadoContratos="";
		let temp:Array<any> = this.listadoUsuarios.filter(item => item.seleccion == true);
		this.listadoUsuarios = this.listadoUsuarios.filter(item => item.seleccion == false);
		

		for(let i of temp){
			i.seleccion = false;
			this.listadoContrato.push( i ) ;
		}
			


	/*	for (let y = indices.length - 1; y >= 0; y--) {
			let x = indices[y];
			if (this.listadoUsuarios[x] != undefined && this.listadoUsuarios[x].seleccion == true) {
				this.listadoUsuarios[x].seleccion = false;
				this.listadoContrato.push(this.listadoUsuarios[x]);
				this.listadoUsuarios.splice(x, 1);
			}
		}
		for (let x = 0; x < this.listadoUsuarios.length; x++) {
			if (this.listadoUsuarios[x] != undefined)
				this.listadoUsuarios[x].seleccion = false;
		}

		for (let y = 0; y < this.listadoContrato.length; y++) {
			if (this.listadoContrato[y] != undefined)
				this.listadoContrato[y].seleccion == false;
		}*/

	}


	public descartar() {
		let indices: Array<number> = new Array();
		for (let y = this.listadoContrato.length - 1; y >= 0; y--) {

			if (this.listadoContrato[y].seleccion == true) {
				console.log(this.listadoContrato[y]);
				indices.push(y);
			}
		}
		for (let x = indices.length - 1; x >= 0; x--) {
			let y = indices[x];
			console.log(this.listadoContrato[y], ' < ---- > ', y);
			if (this.listadoContrato[y] != undefined && this.listadoContrato[y].seleccion == true) {
				this.openSnackBar('Guardando...', 'X');
				let parametros =
				{
					"USUARIO" : JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().usuario).usuario,
					"NUMCONTRATO": this.listadoContrato[y].cnumcont,
					"USUARIOMODIF": this.cusuario,
					"TPEMPRESA": ""+JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa+"",
					"NUM": '2'
				}
	
					this._serviciosGenerales.get('procedure/PRC_ASIGNARCONTRATOS', parametros).subscribe(
					result => {
						console.log(this.listadoContrato[y]);

						this.openSnackBar('Cambios Guardados Correctamente', 'X');


					}, error => {
						this.openSnackBarEspecial('Ocurrió un error mientras se cargan los usuarios del contrato', 'X');
					});
			}
		}

		this.listadoContratos="";
		let temp:Array<opciones> = this.listadoContrato.filter(item => item.seleccion == true);
		this.listadoContrato = this.listadoContrato.filter(item => item.seleccion == false);
		
		
		for(let i of temp){
			i.seleccion = false;
			this.listadoUsuarios.push( i ) ;
		}
			
		
		

		/*for (let x = indices.length - 1; x >= 0; x--) {
			let y = indices[x];
			if (this.listadoContrato[y] != undefined && this.listadoContrato[y].seleccion == true) {
				this.listadoContrato[y].seleccion = false;
				this.listadoUsuarios.push(this.listadoContrato[y]);
				this.listadoContrato.splice(y, 1);
			}

		}

		for (let x = 0; x < this.listadoUsuarios.length; x++) {
			if (this.listadoUsuarios[x] != undefined)
				this.listadoUsuarios[x].seleccion = false;
		}

		for (let y = 0; y < this.listadoContrato.length; y++) {
			if (this.listadoContrato[y] != undefined)
				this.listadoContrato[y].seleccion == false;
		}*/
	}


	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
		
			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

	public mostrarDialogo(): void {
		this.listadoContratos="";
		this.listadoContratosSeleccionadosAsignar();
		this.dialogo
		  .open(DialogoConfirmacionComponent, {
			
			data: '¿Está seguro de asociar los siguientes negocios '+this.listadoContratos+" al usuario "+this.cusuario+'?'
		  })
		  .afterClosed()
		  .subscribe((confirmado: Boolean) => {
			if (confirmado) {
			  this.asignar();
			} 
		  });
		}

		public mostrarDialogoDescartar(): void {
			this.listadoContratos="";
			this.listadoContratosSeleccionadosDescartar();
			this.dialogo
			  .open(DialogoConfirmacionComponent, {
				
				data: '¿Está seguro de desasociar los siguientes negocios '+this.listadoContratos+" al usuario "+this.cusuario+'?'
			  })
			  .afterClosed()
			  .subscribe((confirmado: Boolean) => {
				if (confirmado) {
				  this.descartar();
				} 
			  });
			}


}

export class opciones {
	constructor(public seleccion: boolean, public cnumcont: string) {

	}
}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/AdministracionUsuarios/AsignarContratoUsuarioIndex.component.ts